import Btn from "./Btn";
import SectionLabel from "./SectionLabel";
import Reveal from "./Reveal";
import Img from "./Img";

/** 2026–2027 Trip Leader application banner (links to Workable). */
const ApplyBanner = () => (
  <section className="bg-background py-20 md:py-24">
    <div className="mx-auto max-w-[1200px] px-6">
      <SectionLabel>Trip Leader</SectionLabel>
      <Reveal>
        <div className="mt-10 grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.2fr_1fr]">
          <div>
            <h2 className="max-w-2xl text-4xl md:text-5xl">
              2026–2027 Trip Leader applications
            </h2>
            <div className="mt-8">
              <Btn href="https://apply.workable.com/humanitarianxp/j/4B69EF588B?utm_source=Main_Website_2027&utm_medium=Web">
                Apply Now
              </Btn>
            </div>
          </div>
          <Img
            sizes="(min-width: 1024px) 50vw, 100vw"
            src="/images/trip-leader-street.jpg"
            alt="A Trip Leader talking with Builders on a street during an HXP trip"
            loading="lazy"
            className="w-full rounded-sm border border-hxp-sand-dark object-cover"
          />
        </div>
      </Reveal>
    </div>
  </section>
);

export default ApplyBanner;
